/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListSnippetsSelector = typeof ListSnippetsSelector[keyof typeof ListSnippetsSelector] | null;


export const ListSnippetsSelector = {
  my: 'my',
  shared: 'shared',
} as const;
